// Feb-2026 · Provider-aware CTA label helper.
//
// Every AI-invocation button in the app reads its label from here so
// switching a project's model updates every "Ask …" affordance at
// once. This is the small piece of glue that lets us honor the user's
// request: buttons say "Ask Claude" when Anthropic is selected, "Ask
// OPi" for OpenAI, and "Ask GEMi" for Gemini.

const PROVIDER_LABEL = {
  anthropic: 'Claude',
  openai:    'OPi',
  gemini:    'GEMi',
  deepseek:  'DeepSeek',
};

const PROVIDER_TAGLINE = {
  anthropic: 'Anthropic Claude',
  openai:    'OpenAI',
  gemini:    'Google Gemini',
  deepseek:  'DeepSeek (BYOK)',
};

/**
 * Return a human-readable provider handle for CTA labels.
 * `model` is a MODEL_CATALOG entry (see backend `claude_service.py`).
 */
export function providerHandle(model) {
  const p = (model?.provider || '').toLowerCase();
  return PROVIDER_LABEL[p] || 'AI';
}

/** Full provider name for tooltips / secondary copy. */
export function providerTagline(model) {
  const p = (model?.provider || '').toLowerCase();
  return PROVIDER_TAGLINE[p] || 'AI provider';
}

/**
 * Build a CTA label like "Ask OPi" or "Ask OPi to draft chapter".
 * Pass the verb ("draft chapter", "brainstorm", etc.) as the second arg.
 */
export function askLabel(model, verb) {
  const handle = providerHandle(model);
  return verb ? `Ask ${handle} to ${verb}` : `Ask ${handle}`;
}
